/*
 * @Author: your name
 * @Date: 2020-07-17 16:25:34
 * @LastEditTime: 2020-09-01 21:11:13
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /static-kshdoctor/src/service/SystemMessage.js
 */
import request from '@/utils/request'
import {API} from './apiConfig'

export function getSystemMessageList({uid='',pageNo=1,pageSize=20}){
	return request({
		method: 'get',
		url: API.getSystemMessageList,
		params: {
			pageNo,
			pageSize,
			uid
		}
	})
}
export function getSystemMessageUnreadCount(){
	return request({
		method: 'get',
		url: API.getSystemMessageUnreadCount
	})
}

export function getAppDownLoadUrl(){
	return request({
		method: 'get',
		url: API.getAppDownLoadUrl
	})
}

export function getPlatformLaborEnabled() {
	return request({
		url: API.getPlatformLaborStatus,
		method: 'get',
	})
}
